import axios from "../../../js/project-axios.js";

const list = (appId, username) => {
    return axios.get("/servicer/user/list", {
        params: {
            appId,
            username
        }
    });
};

const search = (username, limit) => {
    return axios.get("/servicer/user/search", {
        params: {
            username,
            limit
        }
    });
};

const invite = appAndUser => {
    return axios.post("/servicer/user/invite", appAndUser);
};

const approve = approve => {
    return axios.post("/servicer/user/approve", approve);
};

export default {
    list,
    search,
    invite,
    approve
};